var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"xs":"12","sm":"12","md":"12","lg":"12"}},[_c('bar-chart',{attrs:{"axis":'y',"chartType":'bar',"title":_vm.title,"subtitle":_vm.subTitle,"data":_vm.chartEvAudiosTip,"extraData":_vm.extraData,"isLoading":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }